






import { Component, Vue } from 'vue-property-decorator';
import { Button } from 'vant';
import { getUrlParam } from '@/utils/common';

@Component({
  name: 'UserInfoCallBack',
  components: {
    [Button.name]: Button
  },
})

export default class UserInfoCallBack extends Vue {
  authCode = '';

  created() {
    this.authCode = getUrlParam('auth_code');
    document.title = '俏租机';
    this.goToApp();
  }

  // 跳转到APP
  goToApp() {
    window.location.href = 'qiaozuji://startapp?path=/pages/index/index' + encodeURIComponent(`?loginBack=true&authCode=${ this.authCode }`);
  }
}
